// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'dev',
  defaultauth: 'fackbackend',
  apiBaseUrl: 'https://api.54.88.218.207.nip.io',
  graphqlEndpoint: 'https://api.54.88.218.207.nip.io/graphql',
  graphqlWsEndpoint: 'wss://api.54.88.218.207.nip.io/graphql',
  // Proxy de fotos: bucket privado cr-assets servido por driver-api GET /media/:filename
  mediaProxyUrl: 'https://driver-api.54.88.218.207.nip.io/media',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
